import { useState } from "react";
import { Link, Outlet } from "react-router-dom";
import { Sidebar } from "@/components/layout/Sidebar";
import { Topbar } from "@/components/layout/Topbar";
import { BottomNav } from "@/components/layout/BottomNav";
import { CommandPalette } from "@/components/layout/CommandPalette";
import { ShortcutsSheet, ViewAsBanner } from "@/components/layout/ShellExtras";
import { GUARDRAIL } from "@/lib/constants";

export default function AppShell() {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem("fcg-sidebar") === "collapsed");
  const toggle = () =>
    setCollapsed((c) => {
      localStorage.setItem("fcg-sidebar", c ? "open" : "collapsed");
      return !c;
    });
  return (
    <div className="flex min-h-screen bg-background">
      <a href="#main" className="skip-link">Skip to content</a>
      <Sidebar collapsed={collapsed} onToggle={toggle} />
      <div className="flex min-w-0 flex-1 flex-col">
        <ViewAsBanner />
        <Topbar />
        <main id="main" tabIndex={-1} className="mx-auto w-full max-w-[1400px] flex-1 px-4 py-8 pb-28 outline-none md:px-8 md:pb-8 lg:px-12">
          <Outlet />
        </main>
        <footer className="border-t px-4 py-4 pb-24 text-xs text-muted-foreground md:px-8 md:pb-4 lg:px-12" data-testid="app-footer">
          <div className="mx-auto flex max-w-[1400px] flex-wrap items-center justify-between gap-2">
            <span>{GUARDRAIL}</span>
            <span className="flex gap-4">
              <Link to="/whats-new" className="hover:text-foreground" data-testid="footer-whats-new">What's new</Link>
              <Link to="/feedback" className="hover:text-foreground" data-testid="footer-feedback">Give feedback</Link>
            </span>
          </div>
        </footer>
      </div>
      <BottomNav />
      <CommandPalette />
      <ShortcutsSheet />
    </div>
  );
}
